/***************AUTH****************/
export const CHANGE_TOKEN = 'CHANGE_TOKEN';
export const CHANGE_STATUS_LOGIN_BY_ADMIN = 'CHANGE_STATUS_LOGIN_BY_ADMIN';
export const CHANGE_PHONE_FORM_SEND_PHONE = 'CHANGE_PHONE_FORM_SEND_PHONE';
export const CHANGE_INTRODUCED_CODE_FORM_SEND_PHONE = 'CHANGE_INTRODUCED_CODE_FORM_SEND_PHONE';
export const CHANGE_LOADER_BTN_FORM_SEND_PHONE = 'CHANGE_LOADER_BTN_FORM_SEND_PHONE';

export const CHANGE_DATA_FORM_LOGIN_STAFF = 'CHANGE_DATA_FORM_LOGIN_STAFF';

export const CHANGE_CODE_FORM_OTP_VALIDATION = 'CHANGE_CODE_FORM_OTP_VALIDATION';
export const CHANGE_LOADER_BTN_FORM_OTP_VALIDATION = 'CHANGE_LOADER_BTN_FORM_OTP_VALIDATION';
export const CHANGE_DATA_FORM_OTP_VALIDATION = 'CHANGE_DATA_FORM_OTP_VALIDATION';

/***************USER****************/
export const CHANGE_DATA_USER = 'CHANGE_DATA_USER';
export const CHANGE_PROFILE_USER = 'CHANGE_PROFILE_USER';
export const EDIT_PROFILE_USER = 'EDIT_PROFILE_USER';
export const RESET_EDIT_PROFILE_USER = 'RESET_EDIT_PROFILE_USER';
export const CHANGE_ITEM_PROFILE_USER = 'CHANGE_ITEM_PROFILE_USER';
export const RESET_PROFILE_USER = 'RESET_PROFILE_USER';

/*Addresses*/
export const SET_LIST_ADDRESSES_USER = 'SET_LIST_ADDRESSES_USER';
export const SET_LIST_AREAS = 'SET_LIST_AREAS';
export const SELECTED_ADDRESS_FOR_DEFAULT = 'SELECTED_ADDRESS_FOR_DEFAULT';
export const CHANGE_DATA_ADD_ADDRESS_PAGE_ADDRESSES = 'CHANGE_DATA_ADD_ADDRESS_PAGE_ADDRESSES';
export const CHANGE_DATA_ADDRESS_PAGE_ADDRESSES = 'CHANGE_DATA_ADDRESS_PAGE_ADDRESSES';

/*ChargeWallet*/
export const CHANGE_INPUT_PRICE_CHARGE_WALLET = 'CHANGE_INPUT_PRICE_CHARGE_WALLET';

/*walletTransactions*/
export const CHANGE_DATA_WALLET = 'CHANGE_DATA_WALLET';
export const CHANGE_LOADER_MODAL_WALLET = 'CHANGE_LOADER_MODAL_WALLET';

/*myFactors*/
export const CHANGE_DATA_FACTORS = 'CHANGE_DATA_FACTORS';
export const CHANGE_LOADER_MY_FACTORS = 'CHANGE_LOADER_MY_FACTORS';

/*MyOrders*/
export const CHANGE_LOADER_MODAL_MY_ORDERS = 'CHANGE_LOADER_MODAL_MY_ORDERS';
export const CHANGE_DATA_MY_ORDERS = 'CHANGE_DATA_MY_ORDERS';
export const CHANGE_TEXT_SURVEY_REAL_TIME = 'CHANGE_TEXT_SURVEY_REAL_TIME';




